import { Avatar } from 'antd';
import { GroupProps } from 'antd/es/avatar';
import { InitiativeStakeholder } from '@sonar-software/sonar-core';
import React from 'react';
import { SonarStakeholder } from '@ui/SonarStakeholder';
import { UserAvatar } from './UserAvatar';

export interface StakeholderAvatarGroupProps extends GroupProps {
	large?: boolean;
	stakeholders: InitiativeStakeholder[];
}

export const StakeholderAvatarGroup: React.FC<StakeholderAvatarGroupProps> = ({ large, stakeholders, ...rest }) =>
	<Avatar.Group { ...rest }>
		{ stakeholders.map((sh) => {
			if (sh.userId === null || sh.userId === undefined) {
				return (
					<SonarStakeholder
						key={ sh.stakeholderId }
						large={ large }
						showTooltip
						stakeholderId={ sh.stakeholderId }
						withFullName={ false } />
				);
			}

			return <UserAvatar
				key={ sh.userId }
				large={ large }
				userId={ sh.userId } />;
		}) }
	</Avatar.Group>;

